import {
  GET_ORDERS,
  FILTER_ORDERS,
  SORT_ORDERS,
  FILTER_SERIAL_NUMBERS,
  GET_SERIAL_NUMBERS,
  SORT_SERIAL_NUMBERS,
  FILTER_DATA_QUALITY_SAP_ORDERS,
  SORT_DATA_QUALITY_SAP_ORDERS,
  GET_DATA_QUALITY_SAP_ORDERS,
  GET_DATA_QUALITY_SAP_ORDERS_BULK,
  SORT_HWS_SNS_TRAIL,
  FILTER_HWS_SNS_TRAIL,
  GET_HWS_SNS_TRAIL,
  GET_HWS_SNS_TRAIL_BULK,
  GET_HWS_SNS_TRAIL_ANALYSIS,
  CALL_HWS_SWAP,
  CLEAN_API_RESPONSE,
  ADD_HWS_SNS_TRAIL_OUT,
  GET_BULK_REPORT,
  SORT_BULK_EXPORT,
  FILTER_BULK_REPORT,
  CHECK_HWS_SWAP,
  CALL_MATERIAL_SWAP,
  GET_MISSING_SNS_STATUS,
  GET_MISSING_SNS_STATUS_BULK,
  FILTER_MISSING_SNS_STATUS,
  SORT_MISSING_SNS_STATUS,
  GET_ORDERS_BULK,
  APP_MONITORING,
  GET_CLIENT_ERRORS,
  GET_CLIENT_ERROR_USERS,
  GET_MONITORING,
  GET_SFDC_SYNCHRONIZER_MONITORING,
  GET_SFDC_SYNCHRONIZER_MONITORING_BULK,
  FILTER_SFDC_SYNCHRONIZER_MONITORING,
  TRIGGER_SFDC_SYNC,
  GET_ATHENA_DATABASES,
  GET_ATHENA_TABLES,
  GET_ATHENA_COLUMNS,
  START_ATHENA_QUERY,
  POLL_ATHENA_QUERY,
  GET_ATHENA_HISTORY,
  CLEAN_ATHENA_QUERY,
  GET_MY_PORTAL_QUERY,
  GET_MY_PORTAL_ANALYTICS,
  UPDATE_MY_PORTAL_OBJECT,
  CLEAN_MY_PORTAL,
  GET_UNPROCESSED_ITEMS,
  GET_UNPROCESSED_ITEM,
  RESEND_UNPROCESSED_ITEM,
  CLEAN_UNPROCESSED_ITEM,
} from "../actions";

import { API } from "@aws-amplify/api";
import config from "../../../aws-exports.js";
import { getFromServer, parseDynamoResult } from "../../global/middleware";
import { customFetch, getAnalyticsContext } from "../../../utils.js";
import { ERROR } from "../../global/actions";

let originalFetch = require("isomorphic-fetch");
let fetch = require("fetch-retry")(originalFetch);

API.configure(config);

let result;
let questObject;
let getDynamoResult;
let parsedResults;
let getResult;
let ordersToExport;
let headers;
let bulkResult;
let url;
let bulkResponse;

export function dynamoMiddleware({ dispatch }) {
  return function (next) {
    return async function (action) {
      switch (action.type) {
        case FILTER_ORDERS:
          break;
        case SORT_SERIAL_NUMBERS:
          break;
        case SORT_DATA_QUALITY_SAP_ORDERS:
          break;
        case SORT_ORDERS:
          break;
        case SORT_HWS_SNS_TRAIL:
          break;
        case ADD_HWS_SNS_TRAIL_OUT:
          break;
        case GET_ORDERS:
          result = [];
          if (action.data?.order_id) {
            questObject = {
              resource: "order",
              params: {
                order_id: action.data.order_id,
              },
            };
            if (action.data?.order_line) {
              questObject.params.order_line = action.data.order_line;
            }

            getDynamoResult = await getFromServer(questObject);
            if (getDynamoResult?.results?.length > 0) {
              action.orders = getDynamoResult.results;
              action.total_count = getDynamoResult.results.length;
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
              console.log(
                "action.errors",
                action.errors,
                "getResult",
                getDynamoResult,
              );
            }
          }

          const {
            extract_date_from,
            extract_date_to,
            part_numbers,
            document_types,
            page,
            limit,
          } = action.data || {};
          const hasFullDate = extract_date_from && extract_date_to;
          const hasParts = !!part_numbers;
          const hasTypes = !!document_types;
          if (hasFullDate || hasParts || hasTypes) {
            const body = {
              ...(hasFullDate && {
                start_period: extract_date_from,
                end_period: extract_date_to,
              }),
              ...(hasParts && { part_numbers }),
              ...(hasTypes && { document_types }),
              page: page,
              page_count: limit,
            };

            const questObject = {
              resource: "orderDlApi",
              body,
            };

            const getDynamoResult = await getFromServer(questObject, "POST");

            if (getDynamoResult?.results?.length > 0) {
              action.orders = getDynamoResult.results;
              if (getDynamoResult?.pagination) {
                action.total_count = getDynamoResult?.pagination?.total_count;
              } else {
                action.total_count = getDynamoResult.results.length;
              }
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
              console.log(
                "action.errors",
                action.errors,
                "getResult",
                getDynamoResult,
              );
            }
          }
          break;
        case GET_ORDERS_BULK:
          questObject = {};
          questObject.params = Object.assign({}, action.data);
          questObject.resource = "order";
          if (questObject.params !== {}) {
            bulkResult = await getFromServer(questObject);
          }
          break;
        case GET_DATA_QUALITY_SAP_ORDERS:
          result = [];
          if (
            action.data?.creation_date_from &&
            action.data?.creation_date_to
          ) {
            questObject = {
              resource: "dataQualitySapOrders",
              params: {
                creation_date_from: action.data.creation_date_from,
                creation_date_to: action.data.creation_date_to,
              },
            };
            if (action.data?.order_id) {
              questObject.params.order_id = action.data.order_id;
            }
            if (action.data?.status) {
              questObject.params.status = action.data.status;
            }
            if (action.data?.sold_to) {
              questObject.params.sold_to = action.data.sold_to;
            }
            if (action.data?.part_number) {
              questObject.params.part_number = action.data.part_number;
            }
            getDynamoResult = await getFromServer(questObject);
            if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
              parsedResults = [];
              for (result of getDynamoResult.results) {
                parsedResults.push(result);
              }
              action.dataQualitySapOrders = parsedResults;
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
              console.log(
                "action.errors",
                action.errors,
                "getResult",
                getDynamoResult,
              );
            }
          }
          break;
        case GET_DATA_QUALITY_SAP_ORDERS_BULK:
          questObject = {};
          questObject = {
            resource: "dataQualitySapOrders",
            params: {
              creation_date_from: action.data.creation_date_from,
              creation_date_to: action.data.creation_date_to,
              is_bulk: action.data.is_bulk,
            },
          };
          if (action.data?.order_id) {
            questObject.params.order_id = action.data.order_id;
          }
          if (action.data?.status) {
            questObject.params.status = action.data.status;
          }
          if (action.data?.sold_to) {
            questObject.params.sold_to = action.data.sold_to;
          }
          if (action.data?.part_number) {
            questObject.params.part_number = action.data.part_number;
          }

          bulkResult = await getFromServer(questObject);
          url = bulkResult?.url;

          if (bulkResult.responseCode >= 400) {
            action.errors = {
              responseCode: bulkResult.responseCode,
              error: bulkResult.error,
            };
            break;
          }
          bulkResponse = await customFetch(url, 10, 3000)
            .catch((err) => {
              console.log("Error:", err);
              return null;
            })
            .then(async (response) => {
              if (response) {
                return {
                  response,
                };
              }
              return null;
            });
          if (bulkResponse) {
            action.bulkResponse = bulkResponse;
          } else {
            action.bulkResponse = null;
            document.cookie = `error=timeout; path=/; max-age=1`;
          }
          break;
        case GET_MISSING_SNS_STATUS:
          result = [];
          questObject = {};
          questObject.params = Object.assign({}, action.data);
          questObject.resource = "missingSnsStatus";
          if (questObject.params !== {}) {
            getDynamoResult = await getFromServer(questObject);
            if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
              parsedResults = [];
              for (result of getDynamoResult.results) {
                parsedResults.push(result);
              }
              action.missingSnsStatus = parsedResults;
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
              console.log(
                "action.errors",
                action.errors,
                "getResult",
                getDynamoResult,
              );
            }
          }

          break;
        case GET_MISSING_SNS_STATUS_BULK:
          questObject = {};
          questObject.params = Object.assign({}, action.data);
          questObject.resource = "missingSnsStatus";
          if (questObject.params !== {}) {
            bulkResult = await getFromServer(questObject);
          }
          break;
        case GET_HWS_SNS_TRAIL:
          result = [];
          if (action.data?.search_type) {
            questObject = {
              resource: "hwsSnsTrail",
              params: {
                search_type: action.data.search_type,
                only_hws_in: action.data.only_hws_in,
              },
            };
            if (action.data?.creation_date_from) {
              questObject.params.creation_date_from =
                action.data.creation_date_from;
            }
            if (action.data?.creation_date_to) {
              questObject.params.creation_date_to =
                action.data.creation_date_to;
            }
            if (action.data?.serial_number) {
              questObject.params.serial_number = action.data.serial_number;
            }
            if (action.data?.order_id) {
              questObject.params.order_id = action.data.order_id;
            }
            if (action.data?.order_line) {
              questObject.params.order_line = action.data.order_line;
            }
            if (action.data?.sold_to) {
              questObject.params.sold_to = action.data.sold_to;
            }
            if (action.data?.bundle_reference) {
              questObject.params.bundle_reference =
                action.data.bundle_reference;
            }
            if (action.data?.business_partner) {
              questObject.params.business_partner =
                action.data.business_partner;
            }
            if (action.data?.support_partner) {
              questObject.params.support_partner = action.data.support_partner;
            }
            if (action.data?.end_customer_id) {
              questObject.params.end_customer_id = action.data.end_customer_id;
            }
            if (action.data?.status) {
              questObject.params.status = action.data.status;
            }
            getDynamoResult = await getFromServer(questObject);
            if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
              parsedResults = [];
              for (result of getDynamoResult.results) {
                parsedResults.push(result);
              }
              action.hwsSnsTrail = parsedResults;
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
              console.log(
                "action.errors",
                action.errors,
                "getResult",
                getDynamoResult,
              );
            }
          }
          break;
        case GET_HWS_SNS_TRAIL_ANALYSIS:
          // Analysis tab: every line of the table (no HWS in filter), filters AND-ed together.
          if (action.data?.search_type) {
            questObject = {
              resource: "hwsSnsTrail",
              params: {
                search_type: action.data.search_type,
                only_hws_in: false,
                combine: "and",
              },
            };
            for (const key of [
              "creation_date_from",
              "creation_date_to",
              "order_id",
              "order_line",
              "status",
              "product_type",
            ]) {
              if (action.data?.[key]) {
                questObject.params[key] = action.data[key];
              }
            }
            getDynamoResult = await getFromServer(questObject);
            if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
              action.hwsSnsTrailAnalysis = [...getDynamoResult.results];
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
            }
          }
          break;
        case GET_HWS_SNS_TRAIL_BULK:
          questObject = {
            resource: "hwsSnsTrail",
            params: {
              search_type: action.data.search_type,
              is_bulk: true,
              only_hws_in: action.data.only_hws_in !== false,
            },
          };
          for (const key of [
            "combine",
            "product_type",
            "email",
            "request_user",
          ]) {
            if (action.data?.[key]) {
              questObject.params[key] = action.data[key];
            }
          }
          if (action.data?.creation_date_from) {
            questObject.params.creation_date_from =
              action.data.creation_date_from;
          }
          if (action.data?.creation_date_to) {
            questObject.params.creation_date_to = action.data.creation_date_to;
          }
          if (action.data?.serial_number) {
            questObject.params.serial_number = action.data.serial_number;
          }
          if (action.data?.order_id) {
            questObject.params.order_id = action.data.order_id;
          }
          if (action.data?.order_line) {
            questObject.params.order_line = action.data.order_line;
          }
          if (action.data?.sold_to) {
            questObject.params.sold_to = action.data.sold_to;
          }
          if (action.data?.bundle_reference) {
            questObject.params.bundle_reference = action.data.bundle_reference;
          }
          if (action.data?.business_partner) {
            questObject.params.business_partner = action.data.business_partner;
          }
          if (action.data?.support_partner) {
            questObject.params.support_partner = action.data.support_partner;
          }
          if (action.data?.end_customer_id) {
            questObject.params.end_customer_id = action.data.end_customer_id;
          }
          if (action.data?.status) {
            questObject.params.status = action.data.status;
          }
          bulkResult = await getFromServer(questObject);
          break;

        case GET_SERIAL_NUMBERS:
          console.log("GET_SERIAL_NUMBERS", action);

          questObject = { params: {} };

          if (action.data?.serial_number) {
            questObject.params.serial_number = action.data?.serial_number;
          }
          if (action.data?.bundle_reference) {
            questObject.params.GSI1PK = action.data?.bundle_reference;
          }
          questObject.resource = "serialNumber";

          getResult = await getFromServer(questObject);
          if (getResult.responseCode < 202 && getResult !== 0) {
            parsedResults = [];
            for (result of getResult.results) {
              parsedResults.push(parseDynamoResult(result));
            }
            action.serialNumbers = parsedResults;
          } else {
            action.errors = { responseCode: getResult.responseCode };
            console.log("action.errors", action.errors, "getResult", getResult);
          }
          break;
        case CALL_MATERIAL_SWAP:
          result = [];
          console.log("Action CALL_MATERIAL_SWAP", action);
          questObject = {
            resource: "materialSwap",
            body: {
              serial_number: action?.materialSwapSns?.serial_number,
              new_serial_number: action?.materialSwapSns?.new_serial_number,
              request_user: action?.materialSwapSns?.request_user,
            },
          };
          getDynamoResult = await getFromServer(questObject, "POST");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            break;
          } else {
            action.errors = getDynamoResult.error;
            console.log(
              "action.errors",
              action.errors,
              "getResult",
              getDynamoResult,
            );
          }
          break;
        case CALL_HWS_SWAP:
          result = [];
          questObject = {
            resource: "snSwap",
            body: {
              serial_number: action?.hwsSwapSns?.serial_number_hws_in,
              new_serial_number: action?.hwsSwapSns?.serial_number_hws_out,
              business_partner: action?.hwsSwapSns?.business_partner_hws_in,
              hws_swap_trail_id: action?.hwsSwapSns?.hws_swap_trail_id,
            },
          };
          getDynamoResult = await getFromServer(questObject, "POST");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            break;
          } else {
            action.errors = getDynamoResult.error;
            console.log(
              "action.errors",
              action.errors,
              "getResult",
              getDynamoResult,
            );
          }
          break;
        case CHECK_HWS_SWAP:
          result = [];
          questObject = {
            resource: "checkSnSwap",
            body: {
              serial_number: action?.hwsSwapSns?.serial_number_hws_in,
              new_serial_number: action?.hwsSwapSns?.serial_number_hws_out,
              business_partner: action?.hwsSwapSns?.business_partner_hws_in,
            },
          };
          getDynamoResult = await getFromServer(questObject, "POST");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            break;
          } else {
            action.errors = getDynamoResult.error;
            console.log(
              "action.errors",
              action.errors,
              "getResult",
              getDynamoResult,
            );
          }
          break;
        case SORT_MISSING_SNS_STATUS:
          break;
        case FILTER_DATA_QUALITY_SAP_ORDERS:
          break;
        case FILTER_MISSING_SNS_STATUS:
          break;
        case FILTER_SERIAL_NUMBERS:
          break;
        case FILTER_HWS_SNS_TRAIL:
          break;
        case CLEAN_API_RESPONSE:
          break;
        case GET_BULK_REPORT:
          result = [];
          if (action.data?.request_user) {
            questObject = {
              resource: "bulkReport",
              params: {
                request_user: action.data.request_user,
              },
            };
            getDynamoResult = await getFromServer(questObject);
            if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
              parsedResults = [];
              for (result of getDynamoResult.results) {
                parsedResults.push(result);
              }
              action.bulkReports = parsedResults;
            } else {
              action.errors = { responseCode: getDynamoResult.responseCode };
              console.log(
                "action.errors",
                action.errors,
                "getResult",
                getDynamoResult,
              );
            }
          }
          break;
        case SORT_BULK_EXPORT:
          break;
        case FILTER_BULK_REPORT:
          break;
        case APP_MONITORING:
          try {
            const context = getAnalyticsContext();
            const payload = {
              ...context,
              event: action.event_type,
              data: action.data || {},
            };
            questObject = {
              resource: "appMonitoring",
              body: payload,
            };
            getDynamoResult = await getFromServer(questObject, "POST");
            if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
              console.log("success APP_MONITORING", questObject);
            } else {
              console.log("APP_MONITORING failed silently", getDynamoResult);
            }
          } catch (e) {
            console.log("APP_MONITORING error (silent)", e);
          }
          break;
        case GET_MONITORING:
          questObject = {
            resource: "appMonitoring",
            params: action.data || {},
          };
          getDynamoResult = await getFromServer(questObject, "GET");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.appMonitoring = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
            console.log(
              "action.errors",
              action.errors,
              "getResult",
              getDynamoResult,
            );
          }
          break;
        case GET_SFDC_SYNCHRONIZER_MONITORING:
          questObject = {
            resource: "sfdcSynchronizerMonitoring",
            params: Object.assign({}, action.data),
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.sfdcSynchronizerMonitoring = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case GET_SFDC_SYNCHRONIZER_MONITORING_BULK:
          questObject = {
            resource: "sfdcSynchronizerMonitoring",
            params: Object.assign({}, action.data, { is_bulk: true }),
          };
          bulkResult = await getFromServer(questObject);
          break;
        case FILTER_SFDC_SYNCHRONIZER_MONITORING:
          break;
        case TRIGGER_SFDC_SYNC:
          questObject = {
            resource: "sfdcSync",
            params: action.data,
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode >= 400) {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case GET_ATHENA_DATABASES:
          questObject = {
            resource: "athenaMetadata",
            params: { type: "databases" },
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.athenaDatabases = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case GET_ATHENA_TABLES:
          questObject = {
            resource: "athenaMetadata",
            params: { type: "tables", database: action.data.database },
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.athenaTables = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case GET_ATHENA_COLUMNS:
          questObject = {
            resource: "athenaMetadata",
            params: {
              type: "columns",
              database: action.data.database,
              table: action.data.table,
            },
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.athenaColumns = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case START_ATHENA_QUERY:
          questObject = {
            resource: "athenaQuery",
            body: action.data,
          };
          getDynamoResult = await getFromServer(questObject, "POST");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.athenaQueryStart = getDynamoResult.results;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case POLL_ATHENA_QUERY:
          questObject = {
            resource: "athenaQuery",
            params: {
              query_execution_id: action.data.query_execution_id,
              request_user: action.data.request_user,
            },
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.athenaQueryResult = getDynamoResult.results;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case GET_ATHENA_HISTORY:
          questObject = {
            resource: "athenaHistory",
            params: { request_user: action.data.request_user },
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.athenaHistory = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case GET_CLIENT_ERRORS:
          questObject = {
            resource: "clientError",
            params: { limit: action.data?.limit || 200 },
          };
          if (action.data?.requestUser) {
            questObject.params.request_user = action.data.requestUser;
          }
          if (action.data?.date) {
            questObject.params.date = action.data.date;
          }
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.clientErrors = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case GET_CLIENT_ERROR_USERS:
          questObject = {
            resource: "clientError",
            params: { type: "users" },
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.clientErrorUsers = getDynamoResult.results;
          } else {
            action.errors = { responseCode: getDynamoResult.responseCode };
          }
          break;
        case CLEAN_ATHENA_QUERY:
          break;
        case GET_MY_PORTAL_QUERY:
          questObject = {
            resource: "myPortalQuery",
            params: Object.assign({}, action.data),
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.myPortalQueryResult = getDynamoResult.results;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case GET_MY_PORTAL_ANALYTICS:
          questObject = {
            resource: "myPortalAnalytics",
            params: { object_id: action.data.object_id },
          };
          if (action.data.date_from) {
            questObject.params.date_from = action.data.date_from;
          }
          if (action.data.date_to) {
            questObject.params.date_to = action.data.date_to;
          }
          // Optional dlapi-v2 filters/breakdown. The booleans must only be sent
          // when the user actually picked a value — an absent param means "no
          // filter", not false.
          if (typeof action.data.is_internal === "boolean") {
            questObject.params.IsInternal = action.data.is_internal;
          }
          if (typeof action.data.is_simulation === "boolean") {
            questObject.params.IsSimulation = action.data.is_simulation;
          }
          if (action.data.aggregate) {
            questObject.params.aggregate = action.data.aggregate;
          }
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            // dlapi-v2's success() spreads the payload at the top level (unlike
            // the se-admin api_structure.response which nests it under `results`).
            action.myPortalAnalytics = getDynamoResult;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case UPDATE_MY_PORTAL_OBJECT:
          questObject = {
            resource: "myPortalObjects",
            body: action.data,
          };
          getDynamoResult = await getFromServer(questObject, "PUT");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.myPortalObjectUpdate = getDynamoResult;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case CLEAN_MY_PORTAL:
          break;
        case GET_UNPROCESSED_ITEMS:
          questObject = {
            resource: "unprocessedItems",
            params: Object.assign({}, action.data),
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.unprocessedItems = getDynamoResult.results;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case GET_UNPROCESSED_ITEM:
          questObject = {
            resource: "unprocessedItem",
            params: Object.assign({}, action.data),
          };
          getDynamoResult = await getFromServer(questObject);
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.unprocessedItem = getDynamoResult.results;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case RESEND_UNPROCESSED_ITEM:
          questObject = {
            resource: "unprocessedItemsResend",
            body: action.data,
          };
          getDynamoResult = await getFromServer(questObject, "POST");
          if (getDynamoResult.responseCode < 202 && getDynamoResult !== 0) {
            action.unprocessedItemResend = getDynamoResult.results;
          } else {
            action.errors = {
              responseCode: getDynamoResult.responseCode,
              error: getDynamoResult.error,
            };
          }
          break;
        case CLEAN_UNPROCESSED_ITEM:
          break;
      }
      return next(action);
    };
  };
}
